import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function Overrings(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='overrings-glance-body'
                cssHeadingClass='overrings-glance-heading'
                cssIconClass='icons8-error'
                Heading={t('Overrings')}
                DataPoint1={props.DP1}
                DataPoint3={props.DP2 + ' ' + t('Checks')}
                showForwardButton={true}
            ></BaseDataGlance>
        </>
    );
}